/**
 * Types shared between main and admin components
 */

import { SortingRule } from "react-table";

export enum Conditional {
  AND = "AND",
  OR = "OR",
}

export type PageOptions = {
  currentPage: number;
  totalPages: number;
  handlePageNumberChange: (pageNumber: number) => void;
  onChangeSort?: (sortBy: SortingRule<Record<string, unknown>>[]) => void;
};

type Item<T> = T extends Array<infer U> ? U : T;

type PickField<T, K extends keyof Item<T>> = T extends Array<any>
  ? Array<Pick<Item<T>, K>>
  : Pick<Item<T>, K>;

export type DeepPick<
  T,
  K extends keyof T,
  SK extends keyof Item<NonNullable<T[K]>>
> = {
  [P in K]:
    | PickField<NonNullable<T[P]>, SK>
    | (null extends T[P] ? null : never)
    | (undefined extends T[P] ? undefined : never);
};
